import {
  Alert,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@apollo/orbit';
import React from 'react';

import { usePrivateSubgraphSyncMutation } from 'src/hooks/useCloudResourceManagement';

import { CommonCloudDedicatedProps, CommonStepProps } from '../shared';

import { LinkPrivateResourceButton } from './LinkPrivateResourceButton';

export type ARNInputFormControlProps = Pick<
  CommonStepProps,
  'errors' | 'setFieldValue' | 'handleBlur' | 'values'
> &
  Pick<
    CommonCloudDedicatedProps,
    'availableUnregisteredResources' | 'setAvailableUnregisteredResources'
  > & {
    sync: ReturnType<typeof usePrivateSubgraphSyncMutation>['sync'];
    sharedResources: ReturnType<typeof usePrivateSubgraphSyncMutation>['data'];
    sharedResourcesLoading: ReturnType<
      typeof usePrivateSubgraphSyncMutation
    >['loading'];
    sharedResourcesError: ReturnType<
      typeof usePrivateSubgraphSyncMutation
    >['error'];
  };

export const ARNInputFormControl = ({
  errors,
  setFieldValue,
  handleBlur,
  values,
  sharedResources,
  sharedResourcesError,
  setAvailableUnregisteredResources,
  sharedResourcesLoading,
  sync,
}: ARNInputFormControlProps) => {
  const hasResources =
    sharedResources?.account?.privateSubgraph?.sync?.length ?? null;

  return (
    <div className="mt-4">
      {hasResources !== null && (
        <Alert status="success" className="my-6">
          Your Amazon Resource Name (ARN) has been linked successfully.{' '}
          {hasResources === 0 ? (
            'There are currently no resources available to share on your account. Please revisit your account within a few minutes to select your first service for the Router.'
          ) : (
            <>
              Click the <span className="font-semibold">Next</span> button to
              select your first service for the Router.
            </>
          )}
        </Alert>
      )}
      {sharedResourcesError && (
        <Alert status="error" className="my-6">
          We cannot complete your request at this time. Please try syncing your
          ARN again within a few minutes.
        </Alert>
      )}
      <FormControl className="my-8" isInvalid={!!errors.arn}>
        <FormLabel className="flex items-center">
          Enter your Amazon Resource Name (ARN){' '}
        </FormLabel>
        <Input
          value={values.arn}
          name="arn"
          onBlur={handleBlur}
          onChange={(e) => setFieldValue('arn', e.target.value)}
        />
        <FormErrorMessage>{errors.arn}</FormErrorMessage>
      </FormControl>
      <LinkPrivateResourceButton
        setAvailableUnregisteredResources={setAvailableUnregisteredResources}
        errors={errors}
        values={values}
        sync={sync}
        sharedResources={sharedResources}
        sharedResourcesLoading={sharedResourcesLoading}
      />
    </div>
  );
};
